export default "__VITE_ASSET__J63BvyKA__"